import * as React from 'react';

export interface StartScreenProps {
  title: string;
  onStart: () => void;
}

export function StartScreen({ title, onStart }: StartScreenProps) {
  return (
    <div className="flex h-full w-full flex-col items-center justify-center gap-10 px-6 py-10">
      <div className="max-w-md text-center">
        <p className="mb-2 text-xs tracking-[0.35em] text-white/55 uppercase">测验</p>
        <h1 className="text-balance text-3xl font-black text-white drop-shadow-md md:text-4xl">{title}</h1>
        <p className="mt-4 text-sm leading-relaxed text-white/65">准备好后点击开始，按顺序作答单选与多选题。</p>
      </div>
      <button
        type="button"
        onClick={onStart}
        className="w-full max-w-sm rounded-2xl bg-white py-4 text-lg font-black tracking-widest text-indigo-900 uppercase shadow-[0_0_30px_rgba(255,255,255,0.25)] transition-transform hover:scale-[1.02] active:scale-[0.98]"
      >
        开始答题
      </button>
    </div>
  );
}
